import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseApproveOrRejectReturnParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useApproveOrRejectReturn(
	params: UseApproveOrRejectReturnParams,
) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/approve-or-reject",
		{
			onSuccess: params.onSuccess,
			mapVariables: ({
				shopId,
				returnRequestId,
				status,
			}: {
				shopId: string;
				returnRequestId: string;
				status: string;
			}) => ({
				params: {
					path: { shopId, returnRequestId },
				},
				body: { status },
			}),
		},
	);
}
